<!-- do not delete this div, it makes the json-viewer scrollable -->
<div>
    <ngx-json-viewer [json]="objectToView" [expanded]="true" [depth]="2" />
</div>
